@if (isFormControlReady) {
  <form class="form-group" [formGroup]="formGroupInput" [class.has-label]="label">
    @if (label) {
      <label for="database-select">{{ label | translate }}</label>
    }
    <p-multiSelect
      id="database-select"
      [formControlName]="formControlNameInput"
      [options]="filtredDatabased"
      [filter]="true"
      [maxSelectedLabels]="1"
      [showToggleAll]="!singleSelect"
      (onFilter)="onFilter($event)"
      (onChange)="onChange($event)"
      size="small"
      (onClear)="clearFilter()"
      [showClear]="true"
      [displaySelectedLabel]="true"
      [loading]="loading"
      fluid
      [panelStyle]="{ 'max-width': '50px' }"
      [scrollHeight]="'150px'"
      optionLabel="databaseName"
      dataKey="databaseID"
      appendTo="body"
      panelStyleClass="custom-multiselect-panel"
    >
      <ng-template let-databases pTemplate="item">
        <div style="font-size: 12px; white-space: normal; word-break: break-word; line-height: 1.4; width: 100%">
          {{ databases.databaseName }}
        </div>
      </ng-template>
    </p-multiSelect>
  </form>
}
